/**
 * Output utility margin classes.
 *
 * @param {number | undefined} margin The margin's value.
 * @param {string} label The class name label.
 * @return {string} The utility class name.
 */

export default function outputMarginClasses(
  margin: number | undefined,
  label: string,
) {
  if (margin === undefined) return;
  if (margin < 0) {
    return `-${label}${margin}`;
  }
  return `${label}-${margin}`;
}
